function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8742 1.21021C22.7786 0.110715 25.159 1.48509 25.159 3.68408L25.159 12.0889L32.4379 16.2914C34.3422 17.3909 34.3422 20.1396 32.4379 21.2391C31.554 21.7494 30.4651 21.7494 29.5813 21.2391L19.9459 15.6761C19.6365 15.4975 19.4459 15.1673 19.4459 14.8101L19.4459 3.68408C19.4459 2.66353 19.9904 1.72049 20.8742 1.21021Z",
  fill: "white",
  fillOpacity: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.83992 3.69194C8.83992 1.49295 11.2204 0.118574 13.1248 1.21807C14.0086 1.72835 14.5531 2.67138 14.5531 3.69194L14.5531 14.8179C14.5531 15.1752 14.3625 15.5053 14.0531 15.684L4.41768 21.247C3.53385 21.7572 2.44493 21.7572 1.5611 21.247C-0.343283 20.1475 -0.343284 17.3987 1.5611 16.2992L8.83992 12.0968L8.83992 3.69194Z",
  fill: "white",
  fillOpacity: 0.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.85731 25.4725L16.4927 19.9095C16.8021 19.7309 17.1833 19.7309 17.4927 19.9095L27.1281 25.4725C28.0119 25.9828 28.5564 26.9258 28.5564 27.9464C28.5564 30.1454 26.1759 31.5198 24.2715 30.4203L16.9927 26.2178L9.71389 30.4203C7.8095 31.5198 5.42902 30.1454 5.42902 27.9464C5.42902 26.9258 5.97348 25.9828 6.85731 25.4725Z",
  fill: "white",
  fillOpacity: 0.5
});

function SvgInfra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfra);
export default __webpack_public_path__ + "static/media/infra.65795905.svg";
export { ForwardRef as ReactComponent };